import { redo } from '@src/actions/wysiwyg/editor';
import { useContext, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';

export default function KeyBindingRedo({ canRedo }: { canRedo: boolean }) {
  const dispatch = useDispatch();
  const { svgRef } = useContext(WysiwygEditorStateContext);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!canRedo) return;

      const activeElement = document.activeElement;

      if (
        activeElement &&
        document.activeElement.classList.contains('ProseMirror')
      ) {
        return;
      }

      const os = /Mac|iPod|iPhone|iPad/i.test(navigator.platform)
        ? 'mac'
        : 'win';

      if (
        (os === 'win' &&
          event.shiftKey &&
          event.ctrlKey &&
          event.key === 'z') ||
        (os === 'mac' && event.shiftKey && event.metaKey && event.key === 'z')
      ) {
        event.preventDefault();

        svgRef.current.dispatchEvent(new Event('blur-content-items'));
        dispatch(redo());
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [canRedo, dispatch]);

  return null;
}
